import axios from 'axios'
import { REFERENCE_TOKEN_KEY } from './auth.js'

// 各环境固定的 token（无需登录态，写死即可）
export const ENVIRONMENT_TOKENS = {
  local: 'Bearer b7b6e4ed-f296-4c01-a8a7-289102caabd4', // 本地环境token
  test: 'Bearer 233dd9c8-a353-4b7b-865a-9f17e0433229',   // 测试环境token
  prod: 'Bearer 233dd9c8-a353-4b7b-865a-9f17e0433229' // 正式环境token
}

// 根据请求/环境的 URL 判断其所属环境类型
export function getEnvTypeByUrl(url) {
  if (!url) return 'local'
  if (url.includes('127.0.0.1') || url.includes('localhost')) return 'local'
  // 测试环境域名包含 -test，需要在正式环境判断之前匹配
  if (url.includes('-test')) return 'test'
  if (url.includes('tianjingyuhong.com')) return 'prod'
  return 'local'
}

// 获取指定环境类型的固定 token
export function getTokenByEnvType(envType) {
  return ENVIRONMENT_TOKENS[envType] || ENVIRONMENT_TOKENS.local || ''
}

// 根据请求 URL 获取对应环境的 token
export function getTokenByUrl(url) {
  return getTokenByEnvType(getEnvTypeByUrl(url))
}

// 参考管理端会把完整登录结果 JSON 存入 token；兼容常见 token 字段名。
export function getLoginToken() {
  const serialized = localStorage.getItem(REFERENCE_TOKEN_KEY)
  if (!serialized) return ''

  try {
    const session = JSON.parse(serialized)
    const token = session?.token || session?.accessToken || session?.access_token || session?.authorization
    if (!token) return ''
    return /^Bearer\s/i.test(token) ? token : `Bearer ${token}`
  } catch (error) {
    return /^Bearer\s/i.test(serialized) ? serialized : `Bearer ${serialized}`
  }
}

// 创建axios实例
const apiClient = axios.create()

// 设备控制等 server 接口继续使用各环境固定的服务密钥。
// 需要 oauth2 登录态的接口应显式调用 getLoginToken，避免两类凭证混用。
apiClient.interceptors.request.use(
  (config) => {
    const token = getTokenByUrl(config.url)
    const configuredAuthorization = config.headers?.get?.('Authorization')
      || config.headers?.Authorization
      || config.headers?.authorization
    if (token && !configuredAuthorization) {
      config.headers.Authorization = token
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default apiClient
